export default "__VITE_ASSET__9cf64ccc__"